import { Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import axios from "utils/axios";
import { ErrorMessage, Field, useFormikContext } from "formik";
import QuillEditorComponent from "./QuillEditorComponent";
import ReactQuill from "react-quill";
import { useSelector } from "react-redux";

const RfqDetailsSection = ({
  // selectedFilesBase,
  // setSelectedFilesBase,
  fieldName,
  updateFormValues = (updatedValues) => { },
  hideAttachments = false,
  attachmentsOnly = false,
  placeholder = "Please write your payment terms here",
  editorClassName = "min-h-[120px] max-h-[200px] h-[120px] custom-quill-editor",
  containerClassName = "w-full",
}) => {
  const user = useSelector((state) => state.auth?.user);
  const entityUploadLimitMB = user?.userEntity?.limits?.rfqFileUploadSize;
  const { values, errors, setFieldValue } = useFormikContext();
  const [attachmentsSkeleton, setAttachmentsSkeleton] = useState([]);
  const [selectedFilesTotalSize, setSelectedFilesTotalSize] = useState([]);
  const [attachmentsUploadsErrors, setAttachmentsUploadsErrors] = useState("");
  const [openFilesSizeError, setOpenFilesSizeError] = useState(false);
  const [selectedFilesBase, setSelectedFilesBase] = useState(values?.attachments || []);



  // const { values } = useFormikContext();

  const MAX_FILE_SIZE = (entityUploadLimitMB && entityUploadLimitMB > 0 ? entityUploadLimitMB : 10) * 1024 * 1024;

  const handleFileUploadClick = (event) => {
    return (event.target.value = "");
  };

  const handleFileUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    // Calculate total size
    const newFilesSize = files.reduce((acc, file) => acc + file.size, 0);
    const existingFilesSize = selectedFilesTotalSize.reduce(
      (acc, file) => acc + (file.FileSize || 0),
      0
    );
    const totalSize = existingFilesSize + newFilesSize;

    if (totalSize > MAX_FILE_SIZE) {
      setOpenFilesSizeError(true);
      setTimeout(() => setOpenFilesSizeError(false), 6000);
      return;
    }

    setAttachmentsSkeleton(prev => [...prev, ...files]);

    try {
      const convertedFiles = await Promise.all(
        files.map((file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e) => {
              const fileContent = e.target.result;
              const encryptedContent = btoa(fileContent);
              let contentType = file.type;

              if (!contentType && file.name.endsWith(".dwg")) {
                contentType = "application/acad";
              }

              resolve({
                Name: file.name,
                Content: encryptedContent,
                ContentType: contentType,
                FileSize: file.size,
              });
            };

            reader.onerror = reject;
            reader.readAsBinaryString(file);
          })
        )
      );

      const response = await axios.post("/api/rfqs/upload/attachments", convertedFiles);
      const uploadedFiles = Array.isArray(response?.data) ? response.data : [];

      setSelectedFilesBase(prev => {
        const updated = [...prev, ...uploadedFiles];
        setFieldValue("attachments", updated);
        return updated;
      });

      setSelectedFilesTotalSize(prev => [
        ...prev,
        ...convertedFiles,
      ]);

    } catch (error) {
      console.error('Upload error:', error);
      setAttachmentsUploadsErrors(
        error.message || 'File upload failed'
      );
      setTimeout(() => setAttachmentsUploadsErrors(''), 5000);
    } finally {
      setAttachmentsSkeleton([]);
    }
  };

  const handleDeleteSelectedFile = (name, event) => {
    const currentValues = { ...values };
    updateFormValues(currentValues);
    event.preventDefault(); // use becuse when we click on chip dont one link
    // setSelectedFilesBase((preVal) =>
    //   preVal.filter((data) => data.Name !== name)
    // );
    const updatedAttachments = currentValues.attachments.filter((data) => data.Name !== name);

    // Set the updated attachments back to Formik's state
    setFieldValue("attachments", updatedAttachments);
    setSelectedFilesTotalSize((preVal) =>
      preVal.filter((data) => data.Name !== name)
    ); // this is use when some file are delet then the data also delet from this array becase of change in total size of selected  file

    setSelectedFilesBase((prev) =>
      prev.filter((data) => data.Name !== name)
    );
  };
  const handleCloseFileSizeError = () => {
    setOpenFilesSizeError(false);
  };

  useEffect(() => {
    if (values?.attachments !== selectedFilesBase) {
      setSelectedFilesBase(values?.attachments || []);
    }
  }, [values?.attachments]);

  const fileUploadInputId = attachmentsOnly
    ? "rfq-supporting-documents-upload"
    : `rfq-supporting-documents-upload-${fieldName || "details"}`;

  const renderAttachments = () => (
    <>
      <div className="flex min-h-[42px] flex-wrap items-center gap-2 rounded-xl border border-dashed border-[#D8D8CB] bg-[#FCFCFA] px-3 py-2">
        <div>
          <input
            accept=".pdf,.jpg,.jpeg,.png,.gif,.xlsx,.xls,.csv,.dwg" // Specify the file types you want to allow
            id={fileUploadInputId}
            type="file"
            disabled={attachmentsSkeleton.length > 0}
            style={{ display: "none" }}
            onClick={handleFileUploadClick}
            onChange={handleFileUpload}
          />
          <label htmlFor={fileUploadInputId}>
            <span
              className={`inline-flex shrink-0 items-center rounded-sm border border-gray-300 bg-white px-2.5 py-1 text-xs font-medium ${
                attachmentsSkeleton.length > 0
                  ? "cursor-wait text-gray-400"
                  : "cursor-pointer text-[#303026] hover:bg-gray-100"
              }`}
            >
              Attach Files
            </span>
          </label>
        </div>
        <span className="shrink-0 text-[11px] text-gray-500">
          Excel, PDF, image, CSV or DWG. Max {entityUploadLimitMB || 10} MB
        </span>

        {selectedFilesBase.length > 0 ? (
          <div className="flex min-w-0 flex-1 flex-wrap gap-1.5">
            {selectedFilesBase.map((file, index) => (
              <a
                href={file.Content}
                target="_blank"
                rel="noopener noreferrer"
                className="flex max-w-full items-center gap-1.5 rounded-full border border-gray-200 bg-white px-2 py-0.5 text-[11px]"
                key={`${file.Name}-${index}`}
              >
                <span className="max-w-[220px] truncate">
                  {file.Name}
                </span>
                <button
                  type="button"
                  className="font-semibold text-red-600 hover:text-red-800"
                  onClick={(event) => handleDeleteSelectedFile(file.Name, event)}
                >
                  x
                </button>
              </a>
            ))}
          </div>
        ) : (
          <span className="text-[11px] text-gray-400">No files attached</span>
        )}
      </div>

      {attachmentsSkeleton.length > 0 && (
        <p className="mt-2 rounded-lg bg-blue-50 px-3 py-2 text-xs text-blue-800">
          Your file is being scanned for upload, be patient and continue to fill
          the rest of the form.
        </p>
      )}

      {attachmentsSkeleton.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {attachmentsSkeleton.map((_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              sx={{ borderRadius: "999px" }}
              width={150}
              height={28}
            />
          ))}
        </div>
      )}

      <div>
        {Boolean(attachmentsUploadsErrors) && (
          <div className="mt-3">
            <p className="rounded-lg bg-red-50 px-3 py-2 text-sm font-semibold text-red-600">
              {attachmentsUploadsErrors}
            </p>
          </div>
        )}
      </div>
      {openFilesSizeError && (
        <div className="fixed bottom-4 left-4 z-[1200]">
          <div className="flex w-[440px] items-center justify-between rounded-lg bg-orange-100 px-4 py-3 text-yellow-900 shadow-md">
            <p>
              Total size of attachments must not exceed{" "}
              {entityUploadLimitMB > 0 ? entityUploadLimitMB : 10} MB
            </p>
            <button
              type="button"
              onClick={handleCloseFileSizeError}
              className="px-2 py-1 focus:outline-none"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      )}
    </>
  );

  if (attachmentsOnly) {
    return <div className="w-full">{renderAttachments()}</div>;
  }

  return (
    <div className={containerClassName}>
      {/* {!values?.acceptCounterTerms && <h3 className="text-[#434343] font-medium pt-4">Attachments</h3>} */}

      {/* <label
        className="block text-base font-bold text-gray-700 p-6 pb-0"
        htmlFor="rfqDetails"
      >
        RFQ Details<span className="text-red-500">*</span>
      </label> */}
      {/* {values?.acceptCounterTerms && <span> */}
      <Field name={fieldName} >
        {({ field, form }) => (
          // <QuillEditorComponent
          //   fieldName={fieldName}
          //   placeholder="Please write your payment terms here"
          //   field={field}
          //   form={form}
          //   className="placeholder:text-xs"
          // />

          <ReactQuill
            // {...field}
            value={values[fieldName]}
            theme="snow" // You can customize the theme as required
            placeholder={placeholder}
            className={editorClassName}
            onChange={(value) => setFieldValue(fieldName, value)} // To handle value change in Formik
            modules={{ toolbar: false }}
          />

        )}
      </Field>
      <div id="rfqDetails"></div>{" "}
      <ErrorMessage
        name="rfqDetails"
        component="div"
        className="text-red-500 text-xs ml-2"
      />
      {/* </span>
      } */}

      {!hideAttachments && renderAttachments()}
    </div >
  );
};

export default RfqDetailsSection;
